listener('change', "#typesize", (el, e) =>  {
	Turbo.visit(el.value);
});

listener('click', '[data-vg-toggle="catalog-product-color"]', (el) =>  {
	let colors = el.closest('.colors-variants'),
		imageData = JSON.parse(el.dataset.image || '{}'),
		imageTarget = el.dataset.vgTarget || '';

	if (imageTarget && imageData.webp && imageData.img) {
		const prdImage = document.querySelector(imageTarget);

		if (prdImage) {
			const img = prdImage.querySelector('img');

			if (img) {
				const picture = img.closest('picture');

				if (picture) {
					Array.from(picture.querySelectorAll('source')).forEach((source) => {
						const sourceImage = source.getAttribute('type') === 'image/webp'
							? imageData.webp
							: imageData.img;

						if (source.hasAttribute('srcset')) {
							source.setAttribute('srcset', sourceImage);
						}
					});
				}

				img.src = imageData.img;
				img.setAttribute('src', imageData.img);

				if (colors) {
					Array.from(colors.querySelectorAll('.colors-variants-fill'))
						.forEach(color => color.classList.remove('active'));
				}

				const colorFill = el.closest('.colors-variants-fill');
				if (colorFill) {
					colorFill.classList.add('active');
				}
			}
		}
	}
}, true);
